import React from 'react'

const AmendVesselDialogContext = React.createContext()

export default AmendVesselDialogContext
